import React from "react";
import { VoteCounterProps, RowOrColumn, VoteCounterDisplay } from "./VoteCounter";
import { VotesConfigData } from "../Shared/Party/PartyConfigData";

import { EventDrivenOverlayViewEvent } from "./Party";
import { UIConfigContext } from "./UIConfigContext";
import { StateManagerContext } from "./StateManagerContext";
import { CreateCSSProperties, FanboxStyling } from "./CSSUtilities";
import { GoogleLogin } from "@react-oauth/google";
import { GoogleLoginHandler } from "../User/CommonAuth";



export type LikesButtonProps = {
    width: number;
    height: number;
    background: string;
    radius?: number;
    fontBase: number;
    voting: VotesConfigData;
    format?: RowOrColumn;
    unlike: boolean;
    matchExpression?: boolean;
    likeStatus?(status: boolean): void;
    text?: string;
    padding?: number;
}

export const LikesButton = ({ width, height, background, radius, fontBase, voting, unlike, likeStatus, matchExpression, format, text, padding }: LikesButtonProps): React.JSX.Element => {
    const stateManager = React.useContext(StateManagerContext);
    const uiConfig = React.useContext(UIConfigContext);
    const [showSignIn, setShowSignIn] = React.useState<boolean>(false);

    const innerStyling: FanboxStyling = {
        width: uiConfig.width * 0.5,
        color: {
            foreground: 'black',
            background: 'white'
        },
        boundary: {
            border: {
                quadType: 'border',
                top: 2,
                bottom: 2,
                left: 2,
                right: 2,
                borderStyle: 'solid',
                color: 'pink',
            }
        },
        font: {
            size: 18,
            weight: 'semiBold'
        },
        position: {
            positioningType: 'absolute',
            top: 0,
        }
    }
    const clickHandler = () => {


        if (stateManager.user().userInformation.signUpComplete) {
            if (voting.userLiked) {
                if (unlike) {
                    voting.userLiked = false;
                    if (likeStatus !== undefined)
                        likeStatus(false);
                }
            }
            else {
                voting.userLiked = true;
                if (likeStatus !== undefined)
                    likeStatus(true);
            }
        }
        else
            setShowSignIn(true);
    }

    const counterProps: VoteCounterProps = {
        voting: voting,
        voteType: 'likes',
        matchExpression: matchExpression ?? true,
        fontBase: fontBase,
        direction: format ?? 'row',
        justify: 'left',
        padding: padding ?? 5,
        clickHandler: clickHandler,
        textFirst: false,
        text: text,

    }

    return (
        <div style={{
            backgroundColor: background,
            borderRadius: (radius ?? 0) + "px",
            width: width + "px",
            minWidth: width + "px",
            maxWidth: width + "px",
            height: height + "px",
            maxHeight: height + "px",
            minHeight: height + "px",
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            position: 'relative'
        }}
            onClick={() => { clickHandler(); }}>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                <VoteCounterDisplay {...counterProps} />
            </div>
            {showSignIn && (() => {

                const css = CreateCSSProperties(innerStyling);

                return <div style={css}>
                    <span>Sign in to like comments</span>
                    <GoogleLogin onSuccess={(credentials) => {
                        GoogleLoginHandler(credentials, stateManager);
                        setShowSignIn(false);
                    }} />
                </div>

            })()}

        </div>
    )

}